import React, { createContext, useContext } from 'react';

interface ApiKeyContextType {
  geminiApiKey: string;
}

const ApiKeyContext = createContext<ApiKeyContextType | null>(null);

export const ApiKeyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Hard-code the API key for now to test if this approach works
  const apiKey = "AIzaSyBIaWeZur3EIISKGu36RuJuh-KzyxLNMCI";

  return (
    <ApiKeyContext.Provider value={{ geminiApiKey: apiKey }}>
      {children}
    </ApiKeyContext.Provider>
  );
};

export const useApiKey = () => {
  const context = useContext(ApiKeyContext);
  if (!context) {
    throw new Error('useApiKey must be used within an ApiKeyProvider');
  }
  return context;
};
